import { dinnerTime, holidays } from "./data.js";

export default class Utils {
  static isHoliday(date) {
    const localeDate = date.toLocaleDateString();

    return (
      holidays.filter((holiday) => {
        if (holiday.toLocaleDateString() === localeDate) {
          return holiday;
        }
      }).length > 0
    );
  }

  static isWeekend(date) {
    const day = date.getDay();
    return day === 0 || day === 6;
  }

  static isDisableDate(date) {
    return Utils.isHoliday(date) || Utils.isWeekend(date);
  }

  static isBetweenLunchTime(dateToCheck) {
    // 1. Get the hours (0-23) and minutes (0-59) from the Date object.
    const hour = dateToCheck.getHours();
    const minute = dateToCheck.getMinutes();

    // 2. Define the start and end of the time range.
    // const START_HOUR = 12; // 12 PM
    // const START_MINUTE = 30;
    const START_HOUR = 13; // 13 PM
    const START_MINUTE = 0;
    const END_HOUR = 14; // 2 PM
    const END_MINUTE = 0;

    // 3. Convert the current time to a single comparable value (e.g., total minutes from midnight)
    const currentTimeInMinutes = hour * 60 + minute;

    // 4. Calculate the start and end times in total minutes.
    const startTimeInMinutes = START_HOUR * 60 + START_MINUTE; // 12 * 60 + 30 = 750
    const endTimeInMinutes = END_HOUR * 60 + END_MINUTE; // 14 * 60 + 0 = 840

    // 5. Check if the current time falls within the range: [12:30, 14:00)
    // The start time (12:30) is inclusive (>=).
    // The end time (14:00) is exclusive (<) to prevent a 14:00:00 time from being included.
    return (
      currentTimeInMinutes >= startTimeInMinutes &&
      currentTimeInMinutes < endTimeInMinutes
    );
  }

  static isDinner(date) {
    const hours = date.getHours();
    return hours >= dinnerTime.from && hours <= dinnerTime.to;
  }

  static hasCoffeeCupIcon(date) {
    const hours = date.getHours();
    const minutes = date.getMinutes();
    return hours === dinnerTime.from && minutes === 0;
  }

  static isValidAppointment(component, appointmentData) {
    const startDate = new Date(appointmentData.startDate);
    const endDate = new Date(appointmentData.endDate);
    const cellDuration = component.option("cellDuration");
    return Utils.isValidAppointmentInterval(startDate, endDate, cellDuration);
  }

  static isValidAppointmentInterval(startDate, endDate, cellDuration) {
    const edgeEndDate = new Date(endDate.getTime() - 1);
    if (!Utils.isValidAppointmentDate(edgeEndDate)) {
      return false;
    }
    const durationInMs = cellDuration * 60 * 1000;
    const date = startDate;
    while (date <= endDate) {
      if (!Utils.isValidAppointmentDate(date)) {
        return false;
      }
      const newDateTime = date.getTime() + durationInMs - 1;
      date.setTime(newDateTime);
    }
    return true;
  }

  static isValidAppointmentDate(date) {
    return (
      !Utils.isHoliday(date) && !Utils.isDinner(date) && !Utils.isWeekend(date)
    );
  }
}
